import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Card, CardContent, Chip, Button } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
const AnnouncementCard = ({ label, gradient, heading, items = [], viewAllHref, viewAllLabel = 'View all updates', paddingTop, paddingBottom, marginTop, marginBottom, maxWidth, fontFamily, fontWeight = 700, componentAlignment = 'center', }) => {
    const theme = useTheme();
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.light)
        : 'transparent';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 6,
            paddingBottom: paddingBottom || 6,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 1100, mx: 'auto', px: 3 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 1, color: 'text.secondary', letterSpacing: 1.5 }, children: label })), heading && (_jsx(Typography, { variant: "h4", sx: {
                        fontWeight: Number(fontWeight) || 700,
                        mb: 4,
                        fontFamily: fontFamily || undefined,
                        color: 'text.primary',
                    }, children: heading })), _jsx(Box, { sx: {
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            md: items.length === 1 ? '1fr' : 'repeat(2, 1fr)',
                            lg: items.length <= 2 ? `repeat(${items.length}, 1fr)` : 'repeat(3, 1fr)',
                        },
                        gap: 3,
                    }, children: items.map((item, index) => (_jsx(Card, { sx: {
                            textAlign: 'left',
                            borderRadius: 2.5,
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow: '0 2px 8px rgba(0,40,85,0.04)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                borderColor: theme.palette.primary.light,
                                boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.08)}`,
                                transform: 'translateY(-4px)',
                            },
                        }, children: _jsxs(CardContent, { sx: { p: 3 }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }, children: [item.category && (_jsx(Chip, { label: item.category, size: "small", sx: {
                                                bgcolor: alpha(theme.palette.primary.main, 0.08),
                                                color: theme.palette.primary.main,
                                                fontWeight: 600,
                                                fontSize: '0.7rem',
                                            } })), item.date && (_jsx(Typography, { variant: "caption", sx: { color: 'text.secondary' }, children: item.date }))] }), _jsx(Typography, { variant: "h6", sx: {
                                        fontWeight: 600,
                                        mb: 1.5,
                                        fontFamily: fontFamily || undefined,
                                        color: 'text.primary',
                                        lineHeight: 1.3,
                                    }, children: item.title }), _jsx(Typography, { variant: "body2", sx: {
                                        color: 'text.secondary',
                                        mb: 2,
                                        lineHeight: 1.6,
                                    }, children: item.summary }), item.href && (_jsx(Button, { href: item.href, size: "small", endIcon: _jsx(ArrowForwardIcon, { sx: { fontSize: 16 } }), sx: {
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        px: 0,
                                        '&:hover': { bgcolor: 'transparent', transform: 'none' },
                                    }, children: "Read more" }))] }) }, index))) }), viewAllHref && (_jsx(Box, { sx: { mt: 4 }, children: _jsx(Button, { href: viewAllHref, variant: "outlined", color: "primary", endIcon: _jsx(ArrowForwardIcon, {}), sx: { fontWeight: 600, px: 4 }, children: viewAllLabel }) }))] }) }));
};
export default AnnouncementCard;
